import { z } from 'zod'
import type { TKey } from '@/lib/i18n'

export function createLoginSchema(t: (key: TKey) => string) {
	return z.object({
		email: z
			.string()
			.min(1, t('common:auth.email_required'))
			.pipe(z.email(t('common:auth.email_invalid'))),
		password: z.string().min(1, t('common:auth.password_required'))
	})
}

export function createSignupSchema(t: (key: TKey) => string) {
	return z
		.object({
			email: z
				.string()
				.min(1, t('common:auth.email_required'))
				.pipe(z.email(t('common:auth.email_invalid'))),
			password: z.string().min(8, t('common:auth.password_min_error')),
			confirmPassword: z
				.string()
				.min(1, t('common:auth.confirm_password_required'))
		})
		.superRefine((data, context) => {
			if (
				data.confirmPassword &&
				data.password !== data.confirmPassword
			) {
				context.addIssue({
					code: 'custom',
					message: t('common:auth.password_mismatch'),
					path: ['confirmPassword']
				})
			}
		})
}
